const { map, filter, pipe, flatten, defaultTo, isEmpty } = require('ramda')

const getJobSubCategories = meCategoryPreference => pipe(
  defaultTo([]),
  filter(({ value }) => meCategoryPreference.includes(value)),
  map(({ subCategories }) => subCategories.map(({ value }) => value)),
  flatten
)

const extractQueryParams = (meJobPreferences, categories, canSeePgaProJob = true) => {
  if (!meJobPreferences || isEmpty(meJobPreferences)) return null
  const { minimumCompensation, openToSeasonal, jobLocations, jobCategories: meJobCategories } = meJobPreferences

  return {
    categories: getJobSubCategories(meJobCategories)(categories),
    salaryRange: {
      baseCompMin: minimumCompensation
    },
    locations: jobLocations
      .filter(v => v)
      .map(state => ({
        name: state,
        code: state
      })),
    seasonal: openToSeasonal,
    excludeProOnly: !canSeePgaProJob
  }
}

module.exports = {
  extractQueryParams,
  getJobSubCategories
}
